// src/api/index.js - 完整版
import request from '../utils/request';

// 认证相关
export const authApi = {
  login: (data) => request.post('/api/auth/login', data),
  getCurrentUser: () => request.get('/api/auth/me'),
  changePassword: (data) => request.post('/api/auth/change-password', data)
};

// 商品相关
export const productApi = {
  getList: (params) => request.get('/api/products', { params }),
  getDetail: (id) => request.get(`/api/products/${id}`),
  create: (data) => request.post('/api/products', data),
  update: (id, data) => request.put(`/api/products/${id}`, data),
  delete: (id) => request.delete(`/api/products/${id}`),
  getLowStock: () => request.get('/api/products/low-stock/list'),
  getHQStock: () => request.get('/api/products/hq-stock'),
  // 查询指定门店的库存商品（不含成本价），"发起调货申请"选择向哪个门店申请时用
  getProductsByStore: (store_id) => request.get(`/api/products/by-store/${store_id}`),
  bulkImport: (data) => request.post('/api/products/bulk-import', data),
  bulkImportMultiSpec: (data) => request.post('/api/products/bulk-import-multispec', data),
  // 某个商品/SKU当前可用的批次列表——购物车多批次提示、库存调整选批次、
  // 发货/主动配发选批次，这几处都在用
  getAvailableBatches: (product_id, sku_id) =>
    request.get(`/api/products/${product_id}/batches`, { params: sku_id ? { sku_id } : {} }),
};

// 销售相关
export const saleApi = {
  create: (data) => request.post('/api/sales', data),
  getList: (params) => request.get('/api/sales', { params }),
  getDetail: (id) => request.get(`/api/sales/${id}`),
  getPending: () => request.get('/api/sales/pending/list'),
  confirm: (order_no) => request.post(`/api/sales/${order_no}/confirm`),
  cancelSale: (order_no) => request.post(`/api/sales/${order_no}/cancel`),
};

// 班次相关
export const shiftApi = {
  start: (data) => request.post('/api/shifts/start', data),
  end: (data) => request.post('/api/shifts/end', data),
  getCurrent: () => request.get('/api/shifts/current'),
  getHistory: (params) => request.get('/api/shifts/history', { params }),
  getDetail: (id) => request.get(`/api/shifts/${id}`)
};

// 报表相关
export const reportApi = {
  getTodayOverview: (params) => request.get('/api/reports/today-overview', { params }),
  getSalesStatistics: (params) => request.get('/api/reports/sales-statistics', { params }),
  getTopProducts: (params) => request.get('/api/reports/top-products', { params }),
  getStaffPerformance: (params) => request.get('/api/reports/staff-performance', { params }),
  getSalesReport: (params) => request.get('/api/reports/sales-report', { params }),
  // 新增：配送方式占比 / 支付方式占比 / 运费概览
  getOrderInsights: (params) => request.get('/api/reports/order-insights', { params }),
};

// 用户管理
export const userApi = {
  getList: (params) => request.get('/api/users', { params }),
  create: (data) => request.post('/api/users', data),
  update: (id, data) => request.put(`/api/users/${id}`, data),
  resetPassword: (id, data) => request.post(`/api/users/${id}/reset-password`, data)
};

// 库存管理
export const inventoryApi = {
  adjust: (data) => request.post('/api/products/inventory/adjust', data),
  batchAdjust: (data) => request.post('/api/products/inventory/batch-adjust', data),
  getLogs: (params) => request.get('/api/products/inventory/logs', { params }),
  getProductLogs: (id) => request.get(`/api/products/${id}/inventory/logs`),
  // 全店批次总览（"库存管理"页面用，含成本价，管理员/店长权限）
  getBatchOverview: (params) => request.get('/api/products/inventory/batches-overview', { params }),
};

// 分类管理
export const categoryApi = {
  getList: () => request.get('/api/categories'),
  getDetail: (id) => request.get(`/api/categories/${id}`),
  create: (data) => request.post('/api/categories', data),
  update: (id, data) => request.put(`/api/categories/${id}`, data),
  delete: (id) => request.delete(`/api/categories/${id}`),
  getStats: () => request.get('/api/categories/stats/overview'),
  bulkImport: (data) => request.post('/api/categories/bulk-import', data),
};

// 单位管理
export const unitApi = {
  getList: (params) => request.get('/api/units', { params }),
  getDetail: (id) => request.get(`/api/units/${id}`),
  getStats: () => request.get('/api/units/stats/overview'),
  create: (data) => request.post('/api/units', data),
  update: (id, data) => request.put(`/api/units/${id}`, data),
  delete: (id) => request.delete(`/api/units/${id}`),
  // 启用/停用——现在租户唯一能对单位做的操作
  toggle: (id, data) => request.put(`/api/units/${id}/toggle`, data)
};

// 上传管理
export const uploadApi = {
  // 第一步：获取预签名URL
  getUploadUrl: async (file) => {
    const response = await request.post('/api/upload/product-image/sign', {
      filename:    file.name,
      contentType: file.type,
    });
    return response.data;
  },

  // 第二步：直传R2（用XHR避开service worker拦截）
  uploadToR2: (uploadUrl, file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl, true);
      xhr.setRequestHeader('Content-Type', file.type);

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log('✅ 上传R2成功 status:', xhr.status);
          resolve(xhr);
        } else {
          console.error('❌ R2错误:', xhr.status, xhr.responseText);
          reject(new Error(`上传失败: ${xhr.status}`));
        }
      };

      xhr.onerror = () => {
        console.error('❌ XHR网络错误');
        reject(new Error('网络错误'));
      };

      xhr.send(file);
    });
  },

  // 完整上传流程
  uploadProductImage: async (file) => {
    console.log('🔵 uploadProductImage 开始:', file.name);

    const { upload_url, public_url, key } = await uploadApi.getUploadUrl(file);
    console.log('✅ 获取预签名URL成功:', public_url);

    await uploadApi.uploadToR2(upload_url, file);
    console.log('✅ 上传R2成功');

    return {
      success: true,
      data: {
        url:          public_url,
        key:          key,
        filename:     key,
        originalname: file.name,
        size:         file.size,
        mimetype:     file.type,
      }
    };
  },

  // 删除图片
  deleteProductImage: (key) => {
    console.log('🗑️ deleteProductImage:', key);
    return request.delete('/api/upload/product-image', {
      data: { key }
    });
  }
};

// 门店管理
export const storeApi = {
  getList: () => request.get('/api/stores'),
  getDetail: (id) => request.get(`/api/stores/${id}`),
  create: (data) => request.post('/api/stores', data),
  update: (id, data) => request.put(`/api/stores/${id}`, data),
  getSummary: (params) => request.get('/api/stores/summary', { params })
};

// 库存划拨
export const stockTransferApi = {
  getList: (params) => request.get('/api/stock-transfers', { params }),
  getDetail: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}`),
  create: (data) => request.post('/api/stock-transfers', data),
  // 总店主动配发（不需要分店先申请），对应后端 POST /api/stock-transfers/direct
  createDirect: (data) => request.post('/api/stock-transfers/direct', data),
  // ⚠️ 修复：之前这里只接收 transfer_no 一个参数，批次系统上线后
  // "确认发货"必须带上 batch_assignments 才能成功，之前的写法会导致
  // 界面上看着能选批次，但实际请求根本没把批次信息发出去
  ship: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/ship`, data),
  getAvailableBatchesForTransfer: (transfer_no) =>
    request.get(`/api/stock-transfers/${transfer_no}/available-batches`),
  receive: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/receive`, data),
  pay: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/pay`, data),
  confirmPayment: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/confirm-payment`),
  cancel: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/cancel`),
  edit: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/edit`, data),
  getLogs: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}/logs`),
  // 总店审批"分店对分店"的调货申请（仅 pending_approval 状态可用）
  approve: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/approve`),
  // 总店驳回"分店对分店"的调货申请，reason 非必填
  reject: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/reject`, data),
};

// 订单管理（H5订单）
export const ordersManageApi = {
  getList: (params) => request.get('/api/orders', { params }),
  getDetail: (id) => request.get(`/api/orders/${id}`),
  assign: (id, data) => request.put(`/api/orders/${id}/assign`, data),
  confirm: (id) => request.put(`/api/orders/${id}/confirm`),
  prepare: (id) => request.put(`/api/orders/${id}/prepare`),
  deliver: (id) => request.put(`/api/orders/${id}/deliver`),
  // ⚠️ 修复：之前这里只接收 id，自提订单核销现在需要传 pickup_code 才能完成，
  // 和之前 stockTransferApi.ship 是同一类问题——漏传第二个参数导致数据传不到后端
  complete: (id, data) => request.put(`/api/orders/${id}/complete`, data),
  // 新增：确认已退款
  confirmRefund: (id, data) => request.put(`/api/orders/${id}/confirm-refund`, data),
  getSettlements: (params) => request.get('/api/orders/settlements', { params })
};

export const shopSettingsApi = {
  getPublicSettings: () => request.get('/api/shop-settings/public'),
  getSettings: () => request.get('/api/shop-settings'),
  updateSettings: (data) => request.put('/api/shop-settings', data),
  getBanners: () => request.get('/api/shop-settings/banners'),
  createBanner: (data) => request.post('/api/shop-settings/banners', data),
  updateBanner: (id, data) => request.put(`/api/shop-settings/banners/${id}`, data),
  deleteBanner: (id) => request.delete(`/api/shop-settings/banners/${id}`)
};

export const customerApi = {
  getList: (params) => request.get('/api/customers', { params }),
  getDetail: (id) => request.get(`/api/customers/${id}`),
  setVip: (id, data) => request.put(`/api/customers/${id}/vip`, data),
  setSuperVip: (id, data) => request.put(`/api/customers/${id}/super-vip`, data),
  getCommissionLogs: (id, params) => request.get(`/api/customers/${id}/commission-logs`, { params }),
  getBalance: (id, params) => request.get(`/api/customers/${id}/balance`, { params }),
  adjustBalance: (id, data) => request.post(`/api/customers/${id}/balance/adjust`, data),
};

// KHQR 支付
export const khqrApi = {
  create: (data) => request.post('/api/khqr/create', data),
  check: (data) => request.post('/api/khqr/check', data),
};

// 满减阶梯规则管理
export const fullReductionApi = {
  getTiers: () => request.get('/api/full-reduction/tiers'),
  saveTiers: (data) => request.put('/api/full-reduction/tiers', data),
};

// 按距离计费阶梯规则管理——和满减是同一套接口风格
export const deliveryFeeApi = {
  getTiers: () => request.get('/api/delivery-fee/tiers'),
  saveTiers: (data) => request.put('/api/delivery-fee/tiers', data),
};

// SKU 规格管理
export const skuApi = {
  getProductSpecs: (product_id) => request.get(`/api/products/${product_id}/specs`),
  saveProductSpecs: (product_id, data) => request.post(`/api/products/${product_id}/specs`, data),
  // ⚠️ 这个接口现在是老版本（不接入批次系统），SKU商品的库存调整已经统一改走
  // inventoryApi.adjust（带上sku_id参数），InventoryDialog.jsx 不再调用这个方法，
  // 保留在这里只是不删除历史代码，不建议再新增调用
  adjustSkuStock: (sku_id, data) => request.post(`/api/skus/${sku_id}/adjust`, data),
};